export type TitleView = "your-titles" | "all-titles" | "supplier-titles";

/**
 * Derives the active title view from the current URL param and user role context.
 *
 * URL scheme:
 *   titles=all      → all-titles
 *   (absent)        → your-titles  (default for non-suppliers)
 *
 * Role override:
 *   isSupplier users are always locked to supplier-titles regardless of the URL param,
 *   because group membership disables individual role assignments — a supplier user can
 *   never simultaneously hold access_overview, so there is no mixed-role state.
 */
export function resolveTitleView(titlesParam: string | null, isSupplier = false): TitleView {
  if (isSupplier) return "supplier-titles";
  if (titlesParam === "all") return "all-titles";
  return "your-titles";
}
